// import React from "react";
// import ReusableDashboardHeader from "../../../Containers/Dasboard/ReusableDashboardHeader";
// import Card from "@material-ui/core/Card";
// import Grid from "@material-ui/core/Grid";
// import { makeStyles } from "@material-ui/core/styles";
// import * as snackbarActions from "../../../Redux/Actions/SnackbarActions/SnackbarActions";
// import { connect } from "react-redux";
// import { bindActionCreators } from "redux";
// import PharmacySnackbar from "../../../Utils/Snackbars/SnackbarUtil";
// import { LoadingGif } from "../../../Utils/Loader";
// import { formatDate } from "../../../Utils/ConvertDate";
// import { formatAmount } from "../../../Utils/formatAmount";
// import { history } from "../../../Helpers/history";
// import { BackButton } from "../../../Utils/FormInputs/BackButton";
// import { ReportsItemList } from "./ItemList";
// import { useDebtorsReportDetails } from "./hooks/useDebtorsReportDetails";
// import {
//   CollapsibleList,
//   DataCell,
//   ItemText,
//   ModuleTable,
// } from "../../../Utils/List/CollapsibleList";
// import TableRow from "@material-ui/core/TableRow";
// import { ReceiveDebtorsPayments } from "./ReceiveDebtorsPayments";
// import { AccountingDrawer } from "../../../Utils/AccountingUtils/AccountingDrawer";
// import { CustomCell } from "../../../Utils/AccountingUtils/CoaList";
// import {
//   CustomPagination,
//   MuiPagination,
// } from "../../../Utils/Tables/CustomTable";
// import Form from "react-bootstrap/Form";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
// import SelectInput from "../../../Utils/FormInputs/SelectInput";
// import Label from "../../../Utils/FormInputs/Label";
// import TextField from "../../../Utils/FormInputs/TextField";
// // import SelectInput from "../../../Utils/FormInputs/SelectInput";
// // import Label from "../../../Utils/FormInputs/Label";
// // import TextField from "../../../Utils/FormInputs/TextField";
// import PrintOutlinedIcon from "@material-ui/icons/PrintOutlined";
// import Tooltip from "@material-ui/core/Tooltip";
// import { usePrint } from "../../../Utils/Template/usePrint";
// import { PayablesDetailsPrint } from "./PayablesDetailsPrint";

// const useStyles = makeStyles((theme) => ({
//   drawerWidth: {
//     width: 800,
//     padding: "16px",
//   },
//   paragraph: {
//     fontSize: "15px",
//     display: "inline-block",
//     marginBottom: "0.8rem",
//     marginRight: "16px",
//   },
//   icon: {
//     width: ".9em",
//     height: ".9em",
//   },
//   iconHolder: {
//     minWidth: "38px ",
//   },
//   item: {
//     borderRight: "1px solid #c7c6c7",
//     borderLeft: "1px solid #c7c6c7",
//     height: "100vh",
//     overflow: "auto",
//     "&::-webkit-scrollbar": {
//       width: "5px",
//       height: "5px",
//     },
//     "&::-webkit-scrollbar-thumb": {
//       backgroundColor: "#c7c6c7",
//       "-webkit-border-radius": "10px",
//       borderRadius: "10px",
//     },
//   },
//   pItem: {
//     borderLeft: "1px solid #c7c6c7",
//   },
//   rounded: {
//     borderRadius: 0,
//   },
//   listText: {
//     textAlign: "right",
//   },
//   approved: {
//     color: "green",
//   },
//   purchased: {
//     color: "#1d5dd3",
//   },
//   canceled: {
//     color: "#D9512C",
//   },
//   pending: {
//     color: "#F29339",
//   },
//   transactions: {
//     padding: "20px 30px",
//   },
// }));

// const headData = [
//   { item: "Product", align: "left" },
//   { item: "Batch#", align: "left" },
//   { item: "Quantity", align: "left" },
//   { item: "Rate", align: "left" },
//   { item: "Amount", align: "left" },
// ];

// const CustomerDebtorReport = ({ actions, snackbars, match }) => {
//   const classes = useStyles();
//   const {
//     data,
//     handleOpen,
//     closeSnackbar,
//     handleClickCustomer,
//     isLoadingDebtors,
//     isLoadingInvoices,
//     searchValue,
//     totalPageCount,
//     isSuccessDebtors,
//     isSuccessInvoices,
//     isErrorDebtors,
//     isErrorInvoices,
//     allDebtors,
//     customer,
//     paymentProps,
//     handleChangeSearch,
//     handleChangeActivePage,
//     date,
//     handleChange,
//     filters,
//     handleSubmit,
//     submitted,
//     activePage,
//     page,
//     rowsPerPage,
//     handleChangeRowsPerPage,
//     handleChangePage,
//   } = useDebtorsReportDetails(actions, match);
//   const { invoices } = data;
//   const { debtors } = allDebtors;
//   const { open, variant, message } = snackbars;
//   const { name } = customer;
//   const { handlePrint, componentRef, getPageMargins } = usePrint("");

//   const { openDialog, handleCloseDialog, handleOpenDialog } = paymentProps;

//   const { filter_by, start_date, end_date } = date;
//   const pagination = (
//     <MuiPagination
//       rowsPerPage={rowsPerPage}
//       page={page}
//       total_count={totalPageCount}
//       handleChangeRowsPerPage={handleChangeRowsPerPage}
//       isTotalCount={true}
//       handleChangePage={handleChangePage}
//       rows={10}
//       colSpan={2}
//       data={debtors}
//     />
//   );


//   return (
//     <div className="journals">
//       <ReusableDashboardHeader
//         component="Accounts Receivables"
//         heading="Customer Balances"
//         subHeading="Bills"
//         link={history.location.pathname}
//       />
//       <PharmacySnackbar
//         open={open}
//         message={message}
//         variant={variant}
//         handleCloseBar={closeSnackbar}
//       />
//       {/* <AccountingDrawer
//         open={openDialog}
//         title={`Payment for ${name}`}
//         handleClose={handleCloseDialog}
//         width={classes.drawerWidth}
//       >
//         <ReceiveDebtorsPayments {...paymentProps} />
//       </AccountingDrawer> */}
//                     <BackButton
//                 text="Receivables"
//                 to={`/customer-outstanding-balance/${customer.id}/${customer.name}`}
//               />
//       <Card elevation={0} classes={{ root: classes.rounded }}>
//         <Grid container spacing={0}>
//           <Grid item xs={6} md={8} classes={{ item: classes.pItem }}>
//             {isLoadingInvoices ? (
//               <div className="text-center mt-5">
//                 <LoadingGif />
//               </div>
//             ) : null}
//             {isSuccessInvoices ? (
//               invoices.length > 0 ? (
//                 <>
//                   <div className="top-bar">
//                     <div className="row">
//                       <div className="col-lg-6">
//                         <p
//                           style={{
//                             fontSize: "18px",
//                             marginTop: "4px",
//                             marginBottom: 0,
//                           }}
//                         >
//                           {name}'s Transactions
//                         </p>
//                       </div>
//                       <div className="col-lg-6">
//                         <div className="text-right">
//                           <div className="btn-group">
//                             <Tooltip title="Print">
//                               <button
//                                 type="button"
//                                 onClick={handlePrint}
//                                 className="btn btn-sm pharmacy-grey-btn"
//                               >
//                                 <PrintOutlinedIcon
//                                   classes={{ root: classes.icon }}
//                                 />
//                               </button>
//                             </Tooltip>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className={classes.transactions}>
//                     <div className="text-right">
//                       {/* <button
//                         type="button"
//                         style={{ marginTop: "0.6rem" }}
//                         onClick={handleOpenDialog}
//                         className="btn btn-sm pharmacy-info-btn mr-2 mb-3"
//                       >
//                         Receive Payment
//                       </button> */}
//                       <div style={{ display: "none" }}>
//                         <div ref={componentRef}>
//                           {getPageMargins}
//                           {invoices.map((invoice, index) => {
//                             console.log("Invoice", invoice);
//                             const products = invoice.products
//                               ? invoice.products
//                               : [];
//                             const purchaseInfo = {
//                               invoice_number: invoice.invoice_number,
//                               paid_amount: invoice.paid_amount,
//                               total_amount: invoice.total_amount,
//                               purchase_date: formatDate(invoice.date),
//                               paid_amount: invoice.paid_amount,
//                             };
//                             return (
//                               <PayablesDetailsPrint
//                                 key={index}
//                                 {...{ products, purchaseInfo }}
//                               />
//                             );
//                           })}
//                         </div>
//                       </div>
//                     </div>
//                     {invoices.map((item, index) => {
//                       const products = item.products ? item.products : [];
//                       const tableData = products.map((row) => {
//                         const rate = row.rate ? row.rate : 0;
//                         const quantity = row.quantity ? row.quantity : 0;
//                         return (
//                           <TableRow key={row.id}>
//                             <DataCell>{row.product_name}</DataCell>
//                             <DataCell>{row.batch_id}</DataCell>
//                             <DataCell>{row.quantity}</DataCell>
//                             <DataCell>{row.rate}</DataCell>
//                             <DataCell>{formatAmount(quantity * rate)}</DataCell>
//                           </TableRow>
//                         );
//                       });
//                       const date = (
//                         <span>
//                           Date:{" "}
//                           <strong>
//                             {item.date ? formatDate(item.date) : ""}
//                           </strong>
//                         </span>
//                       );
//                       const total_amount = item.total_amount
//                         ? formatAmount(item.total_amount)
//                         : 0;
//                       const paid_amount = item.paid_amount
//                         ? formatAmount(item.paid_amount)
//                         : 0;
//                       const due_amount = item.due_amount
//                         ? formatAmount(item.due_amount)
//                         : formatAmount(item.total_amount);
//                       const buttons = (
//                         <>
//                           <ItemText primary={date} />
//                           {/*<ItemText  primary={amount}  />*/}
//                         </>
//                       );

//                       return (
//                         <div key={item.id}>
//                           <CollapsibleList
//                             key={index}
//                             open={item.open}
//                             name={item.invoice_number}
//                             handleOpen={() => handleOpen(item)}
//                             button={buttons}
//                           >
//                             <ModuleTable headData={headData}>
//                               {tableData}
//                               <TableRow>
//                                 <DataCell
//                                   align="right"
//                                   colSpan={headData.length - 1}
//                                 >
//                                   Total Amount
//                                 </DataCell>
//                                 <DataCell>
//                                   <strong>{total_amount}</strong>
//                                 </DataCell>
//                               </TableRow>
//                               <TableRow>
//                                 <CustomCell
//                                   align="right"
//                                   colSpan={headData.length - 1}
//                                 >
//                                   Payment Received
//                                 </CustomCell>
//                                 <CustomCell>
//                                   <strong>{paid_amount}</strong>
//                                 </CustomCell>
//                               </TableRow>
//                               <TableRow>
//                                 <CustomCell
//                                   align="right"
//                                   colSpan={headData.length - 1}
//                                 >
//                                   Amount Due
//                                 </CustomCell>
//                                 <CustomCell>
//                                   <strong>{due_amount}</strong>
//                                 </CustomCell>
//                               </TableRow>
//                             </ModuleTable>
//                           </CollapsibleList>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </>
//               ) : (
//                 <div className="text-center mt-5">No records found</div>
//               )
//             ) : null}
//             {isErrorInvoices ? (
//               <div className="text-center mt-5">
//                 The server did not return a valid response
//               </div>
//             ) : null}
//           </Grid>
//         </Grid>
//       </Card>
//     </div>
//   );
// };

// function mapStateToProps(state) {
//   return {
//     snackbars: state.snackbars,
//   };
// }

// function mapDispatchToProps(dispatch) {
//   return {
//     actions: {
//       snackbarActions: bindActionCreators(snackbarActions, dispatch),
//     },
//   };
// }

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(CustomerDebtorReport);

import React from "react";
import ReusableDashboardHeader from "../../../Containers/Dasboard/ReusableDashboardHeader";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import * as snackbarActions from "../../../Redux/Actions/SnackbarActions/SnackbarActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PharmacySnackbar from "../../../Utils/Snackbars/SnackbarUtil";
import { LoadingGif } from "../../../Utils/Loader";
import { formatDate } from "../../../Utils/ConvertDate";
import { formatAmount } from "../../../Utils/formatAmount";
import { history } from "../../../Helpers/history";
import { BackButton } from "../../../Utils/FormInputs/BackButton";
import { useDebtorsReportDetails } from "./hooks/useDebtorsReportDetails";
import {
  CollapsibleList,
  DataCell,
  ItemText,
  ModuleTable,
} from "../../../Utils/List/CollapsibleList";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import PrintOutlinedIcon from "@material-ui/icons/PrintOutlined";
import { usePrint } from "../../../Utils/Template/usePrint";
import { PayablesDetailsPrint } from "./PayablesDetailsPrint";
import { CustomerDebtorPrint } from "./CustomerDebtorPrint";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    width: "100%",
    padding: "16px",
  },
  transactions: {
    padding: "20px",
    width: "100%",
    boxSizing: "border-box",
  },
  pItem: {
    borderLeft: "1px solid #c7c6c7",
  },
  icon: {
    width: ".9em",
    height: ".9em",
  },
}));

const headData = [
  { item: "Product", align: "left" },
  { item: "Batch#", align: "left" },
  { item: "Quantity", align: "left" },
  { item: "Rate", align: "left" },
  { item: "Amount", align: "left" },
];

const CustomerDebtorReport = ({ actions, snackbars, match }) => {
  const classes = useStyles();
  const {
    data,
    handleOpen,
    closeSnackbar,
    isLoadingInvoices,
    isSuccessInvoices,
    isErrorInvoices,
    allDebtors,
    customer,
    paymentProps,
  } = useDebtorsReportDetails(actions, match);

  const { invoices } = data;
  const { debtors } = allDebtors;
  const { open, variant, message } = snackbars;
  const { name } = customer;
  const { handlePrint, componentRef, getPageMargins } = usePrint("");

  return (
    <div className="journals">
      <ReusableDashboardHeader
        component="Accounts Receivables"
        heading="Customer Balances"
        subHeading="Bills"
        link={history.location.pathname}
      />
      <PharmacySnackbar
        open={open}
        message={message}
        variant={variant}
        handleCloseBar={closeSnackbar}
      />

      <BackButton
        text="Receivables"
        to={`/customer-outstanding-balance/${customer.id}/${customer.name}`}
      />

      <Card elevation={0} classes={{ root: classes.cardRoot }}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={12} classes={{ item: classes.pItem }}>
            {isLoadingInvoices && (
              <div className="text-center mt-5">
                <LoadingGif />
              </div>
            )}

            {isSuccessInvoices ? (
              invoices.length > 0 ? (
                <>
                  {/* Header / Print Button */}
                  <div className="top-bar" style={{ marginBottom: 16 }}>
                    <Grid container alignItems="center">
                      <Grid item xs={6}>
                        <p style={{ fontSize: "18px", margin: 0 }}>
                          {name}'s Transactions
                        </p>
                      </Grid>
                      <Grid item xs={6} style={{ textAlign: "right" }}>
                        <Tooltip title="Print">
                          <button
                            type="button"
                            onClick={handlePrint}
                            className="btn btn-sm pharmacy-grey-btn"
                          >
                            <PrintOutlinedIcon classes={{ root: classes.icon }} />
                          </button>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </div>

                 {/* Hidden Print Data */}
                <div style={{ display: "none" }}>
                  <div ref={componentRef}>
                    {getPageMargins}
                    {invoices.map((invoice, index) => {
                      return (
                        <CustomerDebtorPrint
                          key={index}
                          invoices={[invoice]}   // pass as array
                          customer={customer}    // pass customer object
                        />
                      );
                    })}
                  </div>
                </div>


                  {/* Transactions */}
                  <div className={classes.transactions}>
                    {invoices.map((item, index) => {
                      const products = item.products || [];
                      const tableData = products.map((row) => {
                        const rate = row.rate || 0;
                        const quantity = row.quantity || 0;
                        return (
                          <TableRow key={row.id}>
                            <DataCell>{row.product_name}</DataCell>
                            <DataCell>{row.batch_id}</DataCell>
                            <DataCell>{row.quantity}</DataCell>
                            <DataCell>{row.rate}</DataCell>
                            <DataCell>{formatAmount(quantity * rate)}</DataCell>
                          </TableRow>
                        );
                      });

                      const dateDisplay = (
                        <span>
                          Date: <strong>{item.date ? formatDate(item.date) : ""}</strong>
                        </span>
                      );

                      const total_amount = formatAmount(item.total_amount || 0);
                      const paid_amount = formatAmount(item.paid_amount || 0);
                      const due_amount = formatAmount(item.due_amount || item.total_amount || 0);

                      const buttons = <ItemText primary={dateDisplay} />;

                      return (
                        <div key={item.id}>
                          <CollapsibleList
                            key={index}
                            open={item.open}
                            name={item.invoice_number}
                            handleOpen={() => handleOpen(item)}
                            button={buttons}
                          >
                            <ModuleTable headData={headData}>
                              {tableData}
                              <TableRow>
                                <DataCell align="right" colSpan={headData.length - 1}>
                                  Total Amount
                                </DataCell>
                                <DataCell>
                                  <strong>{total_amount}</strong>
                                </DataCell>
                              </TableRow>
                              <TableRow>
                                <DataCell align="right" colSpan={headData.length - 1}>
                                  Payment Received
                                </DataCell>
                                <DataCell>
                                  <strong>{paid_amount}</strong>
                                </DataCell>
                              </TableRow>
                              <TableRow>
                                <DataCell align="right" colSpan={headData.length - 1}>
                                  Amount Due
                                </DataCell>
                                <DataCell>
                                  <strong>{due_amount}</strong>
                                </DataCell>
                              </TableRow>
                            </ModuleTable>
                          </CollapsibleList>
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : (
                <div className="text-center mt-5">No records found</div>
              )
            ) : null}

            {isErrorInvoices && (
              <div className="text-center mt-5">
                The server did not return a valid response
              </div>
            )}
          </Grid>
        </Grid>
      </Card>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    snackbars: state.snackbars,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      snackbarActions: bindActionCreators(snackbarActions, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDebtorReport);
